module.exports = __webpack_public_path__ + "static/img/index11.b6591a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index11.gif
// module id = nl19
// module chunks = 0